import {Aseprite} from '@theatrejs/plugin-aseprite';import data from './grid.json';import texture from './grid.png';export default new Aseprite(texture, data);